// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable react/state-in-constructor, react/destructuring-assignment, react/no-access-state-in-setstate, react/prop-types, react/jsx-handler-names */
import PropTypes from "prop-types"
import React, { Component } from "react"
import { connect } from "react-redux"
import Cookies from "js-cookie" // dynamic cookies
import { get } from "@kiwicom/frontend-common/utils/get"
import constants from "@kiwicom/frontend-common/consts/config"
import { setOption } from "@kiwicom/frontend-common/services/options/actions"
import RadioButtons from "@kiwicom/frontend-common/components/RadioButtons/RadioButtons"
import NewTextField from "@kiwicom/frontend-common/components/NewTextField/NewTextField"
import Button from "@kiwicom/frontend-common/components/Button/Button"

const apiButtons = [
  {
    label: "production (disabled)",
    // value added later
  },
  {
    value: "mockApiUrl",
    label: "mocks",
  },
  {
    value: "custom",
    label: "custom",
  },
]

export const API_URLS = {
  apiUrl: "https://api.skypicker.com",
  metaApiUrl: "https://api.skypicker.com/meta-search",
  umbrellaUrl: "https://api.skypicker.com/umbrella/graphql",
  bookingApiUrl: "https://booking-api.skypicker.com",
  prebookingApiUrl: "https://booking-api.skypicker.com",
  mmbApiUrl: "https://booking-api.skypicker.com",
  authApiUrl: "https://auth.skypicker.com",
  locationsApiUrl: "https://api.skypicker.com/locations/",
  mockApiUrl: "https://skymock-api.skypicker.com",
  graphqlApiUrl: "https://graphql.kiwi.com/",
  accountGraphqlApi: "https://plexus-prod.skypicker.com/graphql",
  mmb2BasePath: constants.mmb2BasePath,
}

/** "" means mocks are not supported */
const MOCK_API_URLS = {
  metaApiUrl: "https://skymock-api.skypicker.com/meta",
  umbrellaUrl: "",
  graphqlApiUrl: "",

  mmb2BasePath: "http://localhost:3000",
}

class ChangeAPISection extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    apiType: PropTypes.oneOf([
      "apiUrl",
      "metaApiUrl",
      "umbrellaUrl",
      "mockApiUrl",
      "bookingApiUrl",
      "mmbApiUrl",
      "authApiUrl",
      "locationsApiUrl",
      "graphqlApiUrl",
      "accountGraphqlApi",
      "mmb2BasePath",
    ]),
    // connected
    options: PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props)
    const { options, apiType } = this.props

    let selectedType = "custom"
    const currentApiSetUrl = options.get(apiType)
    // set type according to value in options
    if (currentApiSetUrl === API_URLS[apiType]) {
      selectedType = apiType
    } else if (
      get(apiType, MOCK_API_URLS) === currentApiSetUrl ||
      (!MOCK_API_URLS[apiType] && currentApiSetUrl === API_URLS.mockApiUrl)
    ) {
      selectedType = "mockApiUrl"
    }
    this.state = {
      url: currentApiSetUrl, // url set in initDebugWindow
      selectedType,
    }

    this.handleUrlChange = this.handleUrlChange.bind(this)
    this.handleTypeChange = this.handleTypeChange.bind(this)
    this.saveUrl = this.saveUrl.bind(this)
  }

  handleUrlChange(url) {
    const { apiType } = this.props
    let newType = "custom"
    if (url === API_URLS[apiType]) {
      newType = apiType
    } else if (
      (MOCK_API_URLS[apiType] && url === MOCK_API_URLS[apiType]) ||
      (!MOCK_API_URLS[apiType] && url === API_URLS.mockApiUrl)
    ) {
      newType = "mockApiUrl"
    }
    this.setState({
      url: url.startsWith("https://") || url.startsWith("http://") ? url : `https://${url}`,
      selectedType: newType,
    })
  }

  handleTypeChange(type) {
    const { apiType } = this.props
    let newUrl = this.state.url
    if (type === "mockApiUrl") {
      newUrl = MOCK_API_URLS[apiType] || API_URLS.mockApiUrl
    } else if (type === apiType) {
      newUrl = API_URLS[apiType] // should remove cookie and set default
    }
    this.setState({
      url: newUrl,
      selectedType: type,
    })
  }

  saveUrl() {
    if (this.state.url === API_URLS[this.props.apiType]) {
      // setting default production url
      Cookies.remove(`${this.props.apiType}`)
    } else {
      Cookies.set(`${this.props.apiType}`, this.state.url)
    }
    this.props.changeApiUrl(this.state.url)
  }

  render() {
    const { apiType, title, options } = this.props

    apiButtons[0].value = apiType // fill either apiUrl or bookingApiUrl or authApiUrl or locationsApiUrl

    const currentApiSetUrl = options.get(apiType)

    return (
      // Fix this the next time the file is edited. (Flow to TS)
      // eslint-disable-next-line react/jsx-filename-extension
      <div className="ChangeAPISection">
        <h4>{title}</h4>
        <RadioButtons
          modes={apiButtons.filter(
            (apiButton) => !(apiButton.value === "mockApiUrl" && MOCK_API_URLS[apiType] === ""),
          )}
          active={this.state.selectedType}
          handleChange={this.handleTypeChange}
        />
        <div className="ChangeAPISection-content">
          <NewTextField
            value={this.state.url}
            onChange={this.handleUrlChange}
            placeholder={apiType}
          />
          <Button disabled={this.state.url === currentApiSetUrl} onClick={this.saveUrl}>
            Change
          </Button>
        </div>
      </div>
    )
  }
}

export default connect(
  (state) => ({
    options: state.options,
  }),
  (dispatch, props) => ({
    changeApiUrl: (url) => {
      dispatch(setOption(props.apiType, url))
      constants[props.apiType] = url // Hacky way, but hard to change it other way.
    },
  }),
)(ChangeAPISection)
